import React from 'react';
import FeatureFirst from "./FeatureFirst";
import FeatureSecond from "./FeatureSecond";
import FeatureThird from "./FeatureThird";

const Features = ({openModal}) => {
    return (
        <div>
            <FeatureFirst openModal={openModal}/>
            <FeatureSecond openModal={openModal}/>
            <FeatureThird openModal={openModal}/>
        </div>
    );
};

export default Features;